import UIChangeArrow from 'UIComponents/icon/icons/UIChangeArrow';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { Text } from 'foundations-components/components/Text';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DealHistoryTooltip } from '../dealHistory/DealHistoryTooltip';
import { TEN_MIN_IN_MS, THIRTY_DAYS_IN_MS, DEAL_AMOUNT, DEAL_HISTORY_INFO } from '../../constants/DealHistoryConstants';
import { AmountChangeEvent } from '../../types/api/deals';
import { jsx as _jsx } from "react/jsx-runtime";
const USE_LOWER_CASE_MAP = {
  INCREASE: 'increase',
  DECREASE: 'decrease'
};
export const PercentChange = ({
  use
}) => /*#__PURE__*/_jsx(UIChangeArrow, {
  use: USE_LOWER_CASE_MAP[use],
  size: 12
});
export const DealAmountCellDecorator = ({
  deal
}) => {
  const history = deal.history;
  const dealAmountUnchangedOrNull = !history || !history.hs_amount_change_event;
  //in case we have a deal where the amount has been fully removed, we need to check for both history and the amount property itself
  if (dealAmountUnchangedOrNull || !deal.properties.amount) {
    return null;
  }
  if (!deal.properties.amount.timestamp) {
    return null;
  }

  //The history audits endpoint has a latency of 5-10 minutes, so this ensures that we don't display dated values
  const wasModifiedInLastTenMinutes = deal.properties.hs_lastmodifieddate && deal.properties.hs_lastmodifieddate.value ? Date.now() - Number(deal.properties.hs_lastmodifieddate.value) < TEN_MIN_IN_MS : false;
  const wasModifiedInLastMonth = Date.now() - deal.properties.amount.timestamp < THIRTY_DAYS_IN_MS;
  const dealCreatedInPeriodOrNotUpdatedInPeriod = history.hs_created_in_period || wasModifiedInLastTenMinutes || !wasModifiedInLastMonth;

  // we want to show deals edited in the past month but not created in the selected period: https://hubspot.slack.com/archives/CT1NEGM5F/p1643812607384699
  if (dealCreatedInPeriodOrNotUpdatedInPeriod) {
    return null;
  }
  const dealAmountNewOrRemoved = history.hs_amount_change_event === AmountChangeEvent.NEW || history.hs_amount_change_event === AmountChangeEvent.REMOVED;
  if (dealAmountNewOrRemoved && history.hs_amount_change_event) {
    return /*#__PURE__*/_jsx(Text, {
      as: "small",
      marginInlineStart: "100",
      marginBlockStart: "200",
      "data-test-id": "deal-amount-cell-decorator",
      children: /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: DEAL_HISTORY_INFO.dealAmount[history.hs_amount_change_event].tooltipText || ''
        }),
        children: /*#__PURE__*/_jsx(StatusDot, {
          "data-test-id": "deal-amount-cell-decorator-amount-change-status",
          marginInlineEnd: "0",
          use: DEAL_HISTORY_INFO.dealAmount[history.hs_amount_change_event].useKeyWord
        })
      })
    });
  }
  if (history.hs_amount_change_percentage && history.hs_amount_change_percentage !== 0) {
    const direction = history.hs_amount_change_percentage > 0 ? AmountChangeEvent.INCREASE : AmountChangeEvent.DECREASE;
    const changeGreaterThanZero = Math.abs(history.hs_amount_change_percentage) >= 1;
    return changeGreaterThanZero && /*#__PURE__*/_jsx(DealHistoryTooltip, {
      changeDirection: direction,
      changeAmount: history.hs_amount_change_percentage,
      "data-test-id": "deal-amount-cell-decorator",
      property: DEAL_AMOUNT,
      children: /*#__PURE__*/_jsx(Text, {
        as: "small",
        marginInlineStart: "200",
        marginBlockStart: "200",
        "data-test-id": "deal-amount-cell-decorator-amount-change-percentage",
        children: /*#__PURE__*/_jsx(PercentChange, {
          use: direction
        })
      })
    });
  }
  return null;
};